var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 1.62491V5.56241M0.65625 5.56241H4.59375M0.65625 5.56241L3.70125 2.70116C4.40655 1.99551 5.27912 1.48002 6.23753 1.2028C7.19594 0.925574 8.20896 0.895655 9.18206 1.11583C10.1552 1.33601 11.0566 1.7991 11.8023 2.46191C12.5481 3.12471 13.1137 3.96562 13.4466 4.90616M15.0938 12.1249V8.18741M15.0938 8.18741H11.1562M15.0938 8.18741L12.0488 11.0487C11.3434 11.7543 10.4709 12.2698 9.51247 12.547C8.55406 12.8243 7.54104 12.8542 6.56794 12.634C5.59484 12.4138 4.69337 11.9507 3.94765 11.2879C3.20193 10.6251 2.63627 9.78421 2.30344 8.84366",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.59c675ae007ab6e274df30396cddee45.svg";
export { ForwardRef as ReactComponent };